import React from "react";

import styled from "styled-components/macro";

import FnrLoadingBricks from "UI/FnrLoadingBricks";

export default function LoadingBricks() {
  return (
    <Wrapper>
      <Row justifyContent="center">
        <FnrLoadingBricks show color="gray" size={36} />
      </Row>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  height: 169px;
  display: grid;
  place-items: center;
`;

const Row = styled.div`
  display: flex;
  justify-content: ${(p) => p.justifyContent || "flex-start"};
  align-items: center;
  gap: 6px;
  padding-inline: ${(p) => p.paddingInline || 0};
`;
